<form
  *transloco="let t; prefix: 'common'"
  data-testid="provider-registration-form"
  [formGroup]="theForm"
  (ngSubmit)="onSubmit()"
  class="flex flex-col gap-4"
>
  @if (providerContactsResource.isLoading()) {
    <app-loading [size]="LoadingSize.SMALL" />
  } @else {
    <div class="flex flex-col justify-start items-start gap-1">
      <div class="text-sm opacity-75">{{ t('provider.tenders.contact') }}</div>
      <div class="flex flex-row justify-center items-center gap-3">
        <div class="flex items-center gap-2">
          @if (editMode()) {
            <app-form-field
              id="providerContactSelect"
              fieldName="tenderContactPersonUuid"
              type="dropdownSelect"
              [dropDownOptions]="providerContactOptions()"
            ></app-form-field>
          } @else {
            <div class="flex items-center gap-2">
              <span class="whitespace-nowrap" [class.text-red-500]="!selectedContactPersonName()">
                {{ selectedContactPersonName() || t('provider.tenders.contact.missing') }}
              </span>
              @if (!selectedContactPersonName()) {
                <i
                  class="pi pi-exclamation-circle text-red-500"
                  [title]="t('provider.tenders.contact.missing')"
                ></i>
              }
            </div>
          }
        </div>
        <div class="flex gap-1 justify-center">
          @if (editMode()) {
            <p-button
              icon="pi pi-times"
              data-testid="provider-contact-person-save-button"
              [rounded]="true"
              (onClick)="editMode.set(false)"
            ></p-button>
            <p-button
              icon="pi pi-check"
              data-testid="provider-contact-person-save-button"
              type="submit"
              [rounded]="true"
              [disabled]="theForm.invalid"
            ></p-button>
          } @else {
            <button
              type="button"
              class="inline-flex items-center cursor-pointer text-button-red"
              (click)="editMode.set(true)"
            >
              <i class="pi pi-pencil"></i>
            </button>
          }
        </div>
      </div>
    </div>
  }
</form>
